import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=7486c97f&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7486c97f",
  null
  
)

export default component.exports